<script lang="ts">
	import '../app.css';
	import Footer from '$lib/components/footer.svelte';
	import Navigation from '$lib/components/navigation.svelte';
	import Improve from '$lib/components/improve.svelte';
	import { user } from '$lib/stores/user';
	import { displayLanguage } from '$lib/i18n/translation';

	export let data;
	user.set(data.user);
	displayLanguage.set(data.displayLanguage);
</script>

<Navigation></Navigation>
<slot />
<Footer></Footer>

<Improve></Improve>
